export default {
  TOGGLE_DARK_MODE: 'TOGGLE_DARK_MODE',
};
